<!-- Branding loader - shown while fetching branding configuration -->
<!-- <app-branding-loader></app-branding-loader> -->

<!-- @if(notification)
{
    <div class="flex items-center justify-center bg-red-600 text-white font-normal py-1">
        <p [innerHTML]="notification"></p>
        <p-button (click)="hideNotification()">
            <i class="fas fa-times ml-2"></i>
        </p-button>
    </div>

} -->
<router-outlet></router-outlet>
<p-toast></p-toast>

